import React, { useState } from "react";
import { Country as CountryStateCity } from "country-state-city";

const CountrySelect = ({ selectedCountry, onSelectCountry }) => {


  return (
    <div className="pb-2 ml-3 mb-2">
      <select
        id="country"
        value={selectedCountry}
        onChange={onSelectCountry}
        className="border border-gray-300 bg-white w-1/2 text-xs text-grey-700 py-1 pl-3 pr-8 leading-tight rounded-lg focus:outline-none"
      >
        <option value="">Select Country</option>
        {CountryStateCity.getAllCountries().map((country, index) => (
          <option key={index} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelect;
